export default __webpack_public_path__ + "static/media/swing_3.ceb46f94.svg";